import MuiDialogContent from '@mui/material/DialogContent';

import { styled } from 'helpers';

export const SimpleModalContentStyled = styled(MuiDialogContent)`
  &::-webkit-scrollbar {
    width: 8px;
    background-color: transparent;
  }
  &:hover::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.palette.blueGrey['A200']};
    border-radius: 20px;
  }
  &.MuiDialogContent-root {
    padding: 24px 32px 40px 32px;
    margin-right: 8px;
    border: none;
  }
`;
